import React from "react";
import { FormSection, Field } from "redux-form";

import  {
	Card
} from "rhombus-react";

import { SOCIAL_AD_TYPES } from "utils/constants";
import { isDynamic } from "social/DynamicCreativeToggle";
import { assetType } from "social/BuildMethodRadio";
import { FACEBOOK_CAROUSEL_FIELDS } from "social/carousel/FacebookCarouselCardForm";
import { useErrorBanner } from "social/utils";

import FacebookMOMainContent from "social/carousel/FacebookMOMainContent";
import FacebookCardContent from "social/carousel/FacebookCardContent";

export default function FacebookCarouselMO(props){
	const {
		isEditMode,
		libraryId,
		navigationActions,
		isViewOnly,
		showPristineErrors,
		doVersionsExist,
	} = props;
	const adType = SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO;

	const showPristine = showPristineErrors || ["cardCount"]; // Always show at least the card count error

	const errorDisplay = useErrorBanner(adType, showPristine, FACEBOOK_CAROUSEL_FIELDS);

	return (
		<FormSection name={adType}>
			<div className="carousel-modal-content">
				{errorDisplay}
				<div className="form-container">
					<div className="fields">
						<Field {...isDynamic} />
						<Field {...assetType} />
					</div>
				</div>
				<Card
					className="carousel-main-content"
					header="Main Content"
					isCollapsable
					isVisible
				>
					<FacebookMOMainContent
						adType={adType}
						isEditMode={isEditMode}
						isViewOnly={isViewOnly}
						showPristineErrors={showPristineErrors}
						doVersionsExist={doVersionsExist}
					/>
				</Card>
				<FacebookCardContent
					libraryId={libraryId}
					adType={adType}
					isViewOnly={isViewOnly}
					showPristineErrors={showPristineErrors}
					navigationActions={navigationActions}
					doVersionsExist={doVersionsExist}
				/>
			</div>
		</FormSection>
	);
}
